import { ButtonLink } from "design-system/atoms/Button"
import { Progress } from "design-system/atoms/Progress"
import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "design-system/molecules/Card"
import { formatDate } from "lopermut"
import { useTranslation } from "react-i18next"

type Props = {
  subscriptionRenewalDate?: Date
  hasSubscription: boolean
  usedSubscriptionCredits: number
  totalSubscriptionCredits: number
  subscriptionIsError: boolean
}

export function PlanUsage({
  subscriptionRenewalDate,
  hasSubscription,
  usedSubscriptionCredits,
  totalSubscriptionCredits,
  subscriptionIsError,
}: Props) {
  const { t } = useTranslation()

  return (
    <Card>
      <CardHeader className="flex flex-row justify-between items-start w-full min-h-24">
        <div className="flex flex-col gap-1">
          <CardTitle>{t("subscription.usage.title")}</CardTitle>
          {hasSubscription && subscriptionRenewalDate ? (
            <CardDescription>
              {t("subscription.usage.renewalDate", {
                date: formatDate(subscriptionRenewalDate, "PP"),
              })}
            </CardDescription>
          ) : null}
          {!hasSubscription ? (
            <CardDescription className="text-warning">
              {t("subscription.usage.noSubscription")}
            </CardDescription>
          ) : null}
        </div>
        <ButtonLink variant="outline" to="/settings/subscription/plans">
          {t("subscription.plans.cta.viewPlans")}
        </ButtonLink>
      </CardHeader>
      <CardFooter className="flex flex-col justify-between items-start gap-3">
        <div className="flex flex-col gap-1 items-start w-full">
          <Progress
            value={usedSubscriptionCredits}
            max={totalSubscriptionCredits}
            color={subscriptionIsError ? "destructive" : "primary"}
            className="h-3"
          />
          <div className="flex flex-row justify-between w-full text-lg items-center font-mono">
            <span className="text-foreground">{usedSubscriptionCredits}</span>
            <span className="text-muted-foreground">{totalSubscriptionCredits}</span>
          </div>
        </div>
        <div className="flex flex-col gap-1 items-start w-full text-muted-foreground text-sm">
          <span>{t("subscription.usage.planExplanation")}</span>
        </div>
      </CardFooter>
    </Card>
  )
}
